// src/components/accessibility-attributes/accessibility-attributes.tsx
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment AccessibilityHeadingFragment on LodgingHeader {\n    text\n    subText\n    icon {\n      title\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment AccessibilityElementsFragment on PropertyContent {\n    header {\n      text\n      subText\n      icon {\n        title\n      }\n    }\n    items {\n      ... on PropertyContentItemTexts {\n        contents {\n          primary {\n            value\n          }\n        }\n      }\n    }\n    maxColumns\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment AccessibilityContentFragment on PropertyContentSubSection {\n    elementsV2 {\n      elements {\n        ...AccessibilityElementsFragment\n      }\n    }\n    maxColumns\n  }\n  ", "\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  query AccessibilityAttributeQuery($context: ContextInput!, $productIdentifier: ProductIdentifierInput!) {\n    accessibilityContent(context: $context, productIdentifier: $productIdentifier) {\n      accessibilitySection {\n        sections {\n          header {\n            ...AccessibilityHeadingFragment\n          }\n          bodySubSections {\n            ...AccessibilityContentFragment\n          }\n        }\n        sectionName\n      }\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
import React4 from "react";
import { gql as gql4, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutColumns as UitkLayoutColumns2 } from "uitk-react-layout-columns";
import { UitkLayoutGrid, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkParagraph } from "uitk-react-text";
// src/components/accessibility-attributes/accessibility-content.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
// src/components/accessibility-attributes/accessibility-elements.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutColumns, UitkLayoutColumnsItem } from "uitk-react-layout-columns";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkList, UitkListItem } from "uitk-react-list";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
// src/components/accessibility-attributes/accessibility-heading.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading } from "uitk-react-text";
var __AccessibilityHeadingFragment = gql(_templateObject());
var AccessibilityHeading = function (param) {
  var data = param.data,
    heading = param.heading;
  if (!data) {
    return null;
  }
  return data.icon ? /* @__PURE__ */React.createElement(UitkSpacing, {
    padding: {
      inlineend: "two"
    }
  }, /* @__PURE__ */React.createElement(UitkHeading, {
    tag: heading,
    size: 5,
    tabIndex: -1
  }, data.text)) : /* @__PURE__ */React.createElement(UitkSpacing, {
    padding: {
      inlineend: "two"
    }
  }, /* @__PURE__ */React.createElement(UitkHeading, {
    tag: heading,
    size: 4,
    tabIndex: -1
  }, data.text));
};
AccessibilityHeading.displayName = "AccessibilityHeading";
AccessibilityHeading.fragment = __AccessibilityHeadingFragment;
// src/components/accessibility-attributes/accessibility-elements.tsx
var __AccessibilityElementsFragment = gql2(_templateObject1());
var AccessibilityElements = function (param) {
  var data = param.data,
    heading = param.heading,
    key = param.key;
  var _data_header_icon, _data_header, _data;
  if (!((_data = data) === null || _data === void 0 ? void 0 : (_data_header = _data.header) === null || _data_header === void 0 ? void 0 : (_data_header_icon = _data_header.icon) === null || _data_header_icon === void 0 ? void 0 : _data_header_icon.title) || data.items.length === 0) {
    return null;
  }
  var RenderAccessibilityListItem = function (param) {
    var items = param.items;
    return items.map(function (item) {
      return item.contents.map(function (content, index) {
        return /* @__PURE__ */React2.createElement(UitkSpacing2, {
          margin: {
            inlinestart: "four"
          },
          key: index
        }, /* @__PURE__ */React2.createElement(UitkListItem, {
          key: index
        }, /* @__PURE__ */React2.createElement(UitkText, {
          size: 300,
          theme: "standard"
        }, content.primary.value), /* @__PURE__ */React2.createElement("meta", {
          itemProp: "value",
          content: content.text
        })));
      });
    });
  };
  return /* @__PURE__ */React2.createElement(UitkLayoutGridItem, {
    colSpan: key + 1
  }, /* @__PURE__ */React2.createElement(UitkLayoutColumns, {
    minWidth: "half_width",
    space: "twelve"
  }, /* @__PURE__ */React2.createElement(UitkSpacing2, {
    margin: {
      blockend: "twelve"
    }
  }, /* @__PURE__ */React2.createElement(UitkLayoutColumnsItem, {
    forceNoBreak: true
  }, /* @__PURE__ */React2.createElement(React2.Fragment, null, /* @__PURE__ */React2.createElement(UitkLayoutFlex, {
    space: "two"
  }, /* @__PURE__ */React2.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React2.createElement(UitkSpacing2, {
    padding: {
      inlineend: "one"
    }
  }, /* @__PURE__ */React2.createElement(UitkIcon, {
    name: data.header.icon.title,
    size: UitkIconSize.MEDIUM
  }))), /* @__PURE__ */React2.createElement(AccessibilityHeading, {
    data: data.header,
    heading: heading
  })), /* @__PURE__ */React2.createElement(UitkSpacing2, {
    padding: {
      inlinestart: "six",
      blockend: "four",
      blockstart: "two"
    }
  }, /* @__PURE__ */React2.createElement(UitkList, {
    bullet: "no-bullet"
  }, /* @__PURE__ */React2.createElement(RenderAccessibilityListItem, {
    items: data.items
  }))))))));
};
AccessibilityElements.displayName = "AccessibilityElements";
AccessibilityElements.fragment = __AccessibilityElementsFragment;
// src/components/accessibility-attributes/accessibility-content.tsx
var __AccessibilityContentFragment = gql3(_templateObject2(), AccessibilityElements.fragment);
var AccessibilityContent = function (param) {
  var data = param.data,
    heading = param.heading;
  if (!data || !data.elementsV2 || data.elementsV2[0].elements.length === 0) {
    return null;
  }
  return /* @__PURE__ */React3.createElement(React3.Fragment, null, data.elementsV2[0].elements.map(function (element, count) {
    return element.__typename === "PropertyContent" ? /* @__PURE__ */React3.createElement(AccessibilityElements, {
      data: element,
      heading: heading,
      key: count
    }) : null;
  }));
};
AccessibilityContent.displayName = "AccessibilityContent";
AccessibilityContent.fragment = __AccessibilityContentFragment;
// src/components/accessibility-attributes/accessibility-attributes.tsx
var __AccessibilityContentQuery = gql4(_templateObject3(), AccessibilityHeading.fragment, AccessibilityContent.fragment);
var RenderAccessibilityHeader = function (param) {
  var data = param.data;
  return /* @__PURE__ */React4.createElement(React4.Fragment, null, /* @__PURE__ */React4.createElement(AccessibilityHeading, {
    data: data,
    heading: "h2"
  }), /* @__PURE__ */React4.createElement(UitkSpacing3, {
    padding: {
      blockstart: "one",
      blockend: "three"
    }
  }, /* @__PURE__ */React4.createElement(UitkParagraph, null, data.subText)));
};
var RenderAccessibilityContent = function (param) {
  var data = param.data;
  return data.map(function (item, key) {
    return /* @__PURE__ */React4.createElement(AccessibilityContent, {
      data: item,
      heading: "h3",
      key: key
    });
  });
};
var AccessibilityAttributes = function (props) {
  var _data_accessibilityContent, _data, _accessibilityContent_;
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    batchKey = props.batchKey;
  var context = useBexApi().context;
  var DEFAULT_BATCH_KEY = "default-product-details-experience-batch-key";
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__AccessibilityContentQuery, {
      context: {
        batchKey: batchKey !== null && batchKey !== void 0 ? batchKey : DEFAULT_BATCH_KEY
      },
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  if (loading || error || !((_data = data) === null || _data === void 0 ? void 0 : (_data_accessibilityContent = _data.accessibilityContent) === null || _data_accessibilityContent === void 0 ? void 0 : _data_accessibilityContent.accessibilitySection.sections)) {
    return null;
  }
  var _data_accessibilityContent_accessibilitySection_sections_ = data.accessibilityContent.accessibilitySection.sections[0],
    header = _data_accessibilityContent_accessibilitySection_sections_.header,
    accessibilityContent = _data_accessibilityContent_accessibilitySection_sections_.bodySubSections;
  if (!header) {
    return null;
  }
  var elements = (_accessibilityContent_ = accessibilityContent[0]) === null || _accessibilityContent_ === void 0 ? void 0 : _accessibilityContent_.elementsV2[0].elements;
  return /* @__PURE__ */React4.createElement(UitkSpacing3, {
    padding: {
      block: "six",
      small: {
        inline: "three"
      },
      large: {
        inline: "six"
      }
    },
    "aria-label": "aceessibility"
  }, /* @__PURE__ */React4.createElement(UitkCard, {
    className: "uitk-card-roundcorner-all"
  }, /* @__PURE__ */React4.createElement(UitkCardContentSection, null, /* @__PURE__ */React4.createElement(Viewport, null, /* @__PURE__ */React4.createElement(ViewLarge, null, elements.length === 0 ? /* @__PURE__ */React4.createElement(UitkLayoutGrid, {
    columns: 2,
    space: "three"
  }, /* @__PURE__ */React4.createElement(UitkLayoutGridItem2, {
    colSpan: 1,
    rowStart: 1
  }, /* @__PURE__ */React4.createElement(UitkLayoutColumns2, null, /* @__PURE__ */React4.createElement(AccessibilityHeading, {
    data: header,
    heading: "h2"
  }))), /* @__PURE__ */React4.createElement(UitkLayoutGridItem2, {
    colSpan: 2,
    rowStart: 1
  }, /* @__PURE__ */React4.createElement(UitkLayoutColumns2, null, /* @__PURE__ */React4.createElement(UitkSpacing3, null, /* @__PURE__ */React4.createElement(UitkParagraph, null, header.subText))))) : /* @__PURE__ */React4.createElement(UitkLayoutGrid, {
    columns: {
      medium: 3
    },
    space: "six"
  }, /* @__PURE__ */React4.createElement(UitkLayoutGridItem2, {
    colSpan: 1
  }, /* @__PURE__ */React4.createElement(UitkLayoutColumns2, null, /* @__PURE__ */React4.createElement(RenderAccessibilityHeader, {
    data: header
  }))), /* @__PURE__ */React4.createElement(RenderAccessibilityContent, {
    data: accessibilityContent
  }))), /* @__PURE__ */React4.createElement(ViewSmall, null, /* @__PURE__ */React4.createElement(React4.Fragment, null, /* @__PURE__ */React4.createElement(RenderAccessibilityHeader, {
    data: header
  }), /* @__PURE__ */React4.createElement(RenderAccessibilityContent, {
    data: accessibilityContent
  })))))));
};
AccessibilityAttributes.displayName = "sharedUI-AccessibilityAttributes";
// src/__generated__/types.ts
var IdentifierType = /* @__PURE__ */function (IdentifierType2) {
  IdentifierType2["ACTIVITY_ID"] = "ACTIVITY_ID";
  IdentifierType2["CART_ID"] = "CART_ID";
  IdentifierType2["CHECKOUT_SESSION_ID"] = "CHECKOUT_SESSION_ID";
  IdentifierType2["ENTITY_ID"] = "ENTITY_ID";
  IdentifierType2["LEGACY_ORDER_ID"] = "LEGACY_ORDER_ID";
  IdentifierType2["OFFER_ID"] = "OFFER_ID";
  IdentifierType2["ORDER_ID"] = "ORDER_ID";
  IdentifierType2["PROPERTY_ID"] = "PROPERTY_ID";
  return IdentifierType2;
}(IdentifierType || {});
export { AccessibilityAttributes, IdentifierType };